import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowLeft, Home, DoorOpen } from "lucide-react";
import { getHotel } from "@/lib/api";

export default function HotelCabinSelect() {
  const { hotelId } = useParams();
  const navigate = useNavigate();
  const [hotel, setHotel] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadHotel = async () => {
      try {
        const res = await getHotel(hotelId);
        setHotel(res.data);
      } catch (error) {
        console.error("Error loading hotel:", error);
        navigate("/");
      } finally {
        setLoading(false);
      }
    };
    loadHotel();
  }, [hotelId, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-stone-100 to-stone-200 flex items-center justify-center">
        <p className="text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (!hotel) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-100 to-stone-200">
      {/* Header */}
      <div className="bg-primary text-white">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <Link to="/" className="inline-flex items-center text-white/80 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Amayas Corcovado
          </Link>
          <h1 className="font-display text-3xl md:text-4xl font-bold">
            {hotel.name}
          </h1>
          <p className="text-white/80 mt-2">
            Select your cabin to manage your reservation
          </p>
        </div>
      </div>

      {/* Cabins Grid */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {hotel.cabins.map((cabin) => (
            <Link 
              key={cabin.id} 
              to={`/reserve/${hotelId}/${cabin.id}`}
            >
              <Card className="h-full bg-card hover:shadow-lg transition-all hover:scale-[1.02] cursor-pointer border-border group">
                <CardContent className="p-4 text-center">
                  <div className="w-10 h-10 mx-auto mb-2 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                    <DoorOpen className="w-5 h-5" />
                  </div>
                  <h3 className="font-medium text-foreground">{cabin.name}</h3>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
